/* eslint-disable import/prefer-default-export */
export { default as Logo } from './logo.png';
